module.exports = __webpack_public_path__ + "img/blimpy7.0b8a7dad.jpg";